import styled, { css } from "styled-components"

export default {
    "Aside": styled.aside`
        display: flex;
        flex-direction: column;
        flex-basis: 200px;
        flex-shrink: 0;
        position: relative;
        padding: 24px 20px;
        border-top: 1px solid ${({ theme }) => theme.color.grey1};
    `,
    "MenuList": styled.div`
        display: flex;
        flex-direction: column;
        gap: 20px;
    `,
    "CategoryDiv": styled.div`
        display: flex;
        flex-direction: column;
        gap: 4px;

        & > h2 {
            ${({ theme }) => theme.font.extra_small_bold}
            padding-bottom: 4px;
        }
    `,
    "Element": styled.button`
        color: ${({ theme }) => theme.color.grey4};
        ${({ theme }) => theme.font.extra_small};
        text-align: left;

        ${({ $nowPage }) => $nowPage && css`
            color: ${({ theme }) => theme.color.major};
            ${({ theme }) => theme.font.extra_small_bold};
        `}
    `,
    "EditBtn": styled.button`
        width: 100%;
        position: absolute;
        bottom: 56px;
        left: 0;
        background-color: ${({ theme }) => theme.color.grey3};
        color: ${({ theme }) => theme.color.white};
        ${({ theme }) => theme.font.extra_small_bold};
        padding: 18px 0;
    `,
    "LogoutBtn": styled.button`
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        background-color: ${({ theme }) => theme.color.grey4};
        color: ${({ theme }) => theme.color.white};
        ${({ theme }) => theme.font.extra_small_bold};
        padding: 18px 0;
    `,
}